import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { useState } from 'react';
import maestroService from '../maestroService';
import { dispararAcaoSimulada } from '../utils/acaoSimulada';

interface ModalResetarSetupProps {
  aberto: boolean;
  onFechar: () => void;
  onResetado: () => void;
}

// Restrito a Master no backend (MaestroModuleSetupService.ResetarAsync) — mesmo padrão de reset de
// onboarding do Workflow SOX: exige justificativa (trilha de auditoria via audit_log genérico) e
// zera as 8 etapas + status do setup, sem afetar ciclos/atividades já existentes.
const ModalResetarSetup: React.FC<ModalResetarSetupProps> = ({ aberto, onFechar, onResetado }) => {
  const [justificativa, setJustificativa] = useState('');
  const [enviando, setEnviando] = useState(false);

  const confirmar = () => {
    if (!justificativa.trim()) return;
    setEnviando(true);
    maestroService.resetarSetup(justificativa.trim())
      .then(() => { onResetado(); onFechar(); setJustificativa(''); })
      .catch((e: any) => dispararAcaoSimulada(e?.response?.data?.message ?? 'Não foi possível resetar o setup.'))
      .finally(() => setEnviando(false));
  };

  return (
    <Dialog open={aberto} onClose={onFechar} maxWidth='sm' fullWidth PaperProps={{ className: 'mc-dialog' }}>
      <DialogTitle>Resetar Setup do Maestro</DialogTitle>
      <DialogContent>
        <div className='mc-wizard-bloqueio'>
          <strong><i className='bi bi-exclamation-triangle' /> Ação restrita a Master — irreversível</strong>
          <p>As 8 etapas voltam a "pendente" e o status volta para AGUARDANDO_CONFIGURACAO. Ciclos e atividades já existentes não são afetados — só a configuração inicial do módulo é zerada.</p>
        </div>
        <label className='mc-campo'>
          Justificativa (obrigatória — fica registrada na trilha de auditoria)
          <textarea
            rows={3}
            value={justificativa}
            onChange={e => setJustificativa(e.target.value)}
            placeholder='Motivo do reset (ex.: reconfiguração após mudança de estrutura organizacional)...'
          />
        </label>
      </DialogContent>
      <DialogActions>
        <button type='button' className='mc-btn mc-btn--secondary' onClick={onFechar}>Cancelar</button>
        <button type='button' className='mc-btn mc-btn--danger' disabled={enviando || !justificativa.trim()} onClick={confirmar}>
          {enviando ? 'Resetando...' : 'Resetar setup'}
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalResetarSetup;
